import FormattedMessage from 'I18n/components/FormattedMessage';
import { useUpdateAllowedAppPermissionsMutation } from '../../../__generated__/chirp/com/hubspot/applications/governance/rpc/ApplicationGovernanceAppAuthRpc.hooks';
import { GET_APP_GOVERNANCE_PERMISSIONS_QUERY } from '../../../__generated__/chirp/com/hubspot/applications/governance/rpc/ApplicationGovernanceAppAuthRpc.dfc.new';
import { useApp } from '../../contexts/AppContext';
import { useCaptureError } from '../useCaptureError';

// Merges the isAllowed values from the mutation response into the cached permissions,
// preserving all other fields from the cache while updating only isAllowed.
import { jsx as _jsx } from "react/jsx-runtime";
const mergePermissionAllowedState = (cachedPermissions, responsePermissions) => {
  const responseMap = new Map(responsePermissions.map(p => [p.id, p.isAllowed]));
  return cachedPermissions.map(permission => {
    var _responseMap$get;
    return Object.assign({}, permission, {
      isAllowed: (_responseMap$get = responseMap.get(permission.id)) !== null && _responseMap$get !== void 0 ? _responseMap$get : false
    });
  });
};
const ERROR_CONFIG = {
  message: 'Error updating allowed app permissions',
  alert: {
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app-governance-lib.errorBoundary.default.title"
    }),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app-governance-lib.dataPermissions.permissionsList.error.message"
    })
  }
};
export function useUpdateAllowedAppPermissions() {
  const {
    appId
  } = useApp();
  const [updateAllowedAppPermissions, {
    loading,
    error
  }] = useUpdateAllowedAppPermissionsMutation({
    update: (cache, {
      data
    }) => {
      var _existingData$result$;
      if (!data) {
        return;
      }
      const existingData = cache.readQuery({
        query: GET_APP_GOVERNANCE_PERMISSIONS_QUERY,
        variables: {
          appId
        }
      });
      if (!existingData) {
        return;
      }
      const conditionallyRequiredAppPermissions = data.result.conditionallyRequiredAppPermissions != null ? mergePermissionAllowedState((_existingData$result$ = existingData.result.conditionallyRequiredAppPermissions) !== null && _existingData$result$ !== void 0 ? _existingData$result$ : [], data.result.conditionallyRequiredAppPermissions) : existingData.result.conditionallyRequiredAppPermissions;
      cache.writeQuery({
        query: GET_APP_GOVERNANCE_PERMISSIONS_QUERY,
        variables: {
          appId
        },
        data: Object.assign({}, existingData, {
          result: Object.assign({}, existingData.result, {
            optionalAppPermissions: mergePermissionAllowedState(existingData.result.optionalAppPermissions, data.result.optionalAppPermissions),
            conditionallyRequiredAppPermissions
          })
        })
      });
    }
  });
  useCaptureError(error, ERROR_CONFIG);
  return {
    updateAllowedAppPermissions,
    loading,
    error
  };
}